"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveStaffApi = exports.createStaffApi = void 0;
const apiPath_1 = require("../apiPath");
const createStaffApi = async (axiosInstance, form) => {
    try {
        const data = await axiosInstance.post(apiPath_1.API_PATH.staff.create.frontend, form);
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.createStaffApi = createStaffApi;
const getActiveStaffApi = async (axiosInstance) => {
    try {
        const data = await axiosInstance.get(apiPath_1.API_PATH.staff.getActiveStaffs.frontend);
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getActiveStaffApi = getActiveStaffApi;
//# sourceMappingURL=staff.js.map